import {
  SET_TEST_ID,
  SET_TEST_NAME,
  SET_VALUE,
  SET_QUESTION_INDEX,
  SET_CANDIDATE_SETTING,
  SET_TEST_DATE,
  SET_TEST_TIME,
  SET_REMAINING_TIME,
  SET_TEST_INSTRUCTIONS,
  SET_TEST_SETTINGS,
  SET_COMPANY,
  SET_TOTAL_SCORE,
  SET_TOTAL_QUESTIONS,
  SET_ANSWER,
  SET_LINK,
  RESET_ANSWER,
  SET_TEST_DATA,
  SET_FULL_SCREEN,
  LOGOUT,
  SET_IS_SUBMITTED,
  SET_ALL_SELECTED_ANSWERS,
  SET_PREVIOUS_SPENT_TIME,
  SET_TEST_STATUS,
  RECORD_QUESTION_CHEATING,
  SET_CLIENT_ID,
  SET_JOB_ID,
  RESET_ALL_ANSWERS,
  SET_HAS_PROMO_VIDEO,
} from "./actionTypes";

const initialState = {
  testId: null,
  name: null,
  value: null,
  index: null,
  candidate: null,
  date: null,
  time: null,
  newTime: null,
  screen: null,
  instructions: null,
  setting: null,
  data: null,
  company: null,
  score: null,
  questions: null,
  selectedAnswers: {},
  testLink: null,
  logout: null,
  isSubmitted: false,
  previousSpentTime: null,
  status: null,
  clientId: null,
  jobId: null,
  hasPromoVideo: null,
};

const testReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEST_ID:
      return {
        ...state,
        testId: action.payload,
      };
    case SET_TEST_NAME:
      return {
        ...state,
        name: action.payload,
      };

    case SET_TEST_STATUS:
      return {
        ...state,
        status: action.payload,
      };

    case SET_VALUE:
      return {
        ...state,
        value: action.payload,
      };
    case SET_QUESTION_INDEX:
      return {
        ...state,
        index: action.payload,
      };
    case SET_TEST_INSTRUCTIONS:
      return {
        ...state,
        instructions: action.payload,
      };
    case SET_CANDIDATE_SETTING:
      return {
        ...state,
        candidate: action.payload,
      };
    case SET_TEST_DATE:
      return {
        ...state,
        date: action.payload,
      };
    case SET_LINK:
      return {
        ...state,
        testLink: action.payload,
      };

    case SET_TEST_TIME:
      return {
        ...state,
        time: action.payload,
      };
    case SET_REMAINING_TIME:
      return {
        ...state,
        newTime: action.payload,
      };
    case SET_FULL_SCREEN:
      return {
        ...state,
        screen: action.payload,
      };
    case SET_TEST_SETTINGS:
      return {
        ...state,
        setting: action.payload,
      };
    case SET_COMPANY:
      return {
        ...state,
        company: action.payload,
      };
    case SET_TOTAL_SCORE:
      return {
        ...state,
        score: action.payload,
      };
    case SET_TEST_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case SET_TOTAL_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
      };

    case SET_ANSWER:
      const {
        questionId,
        selectedAnswer,
        isAnswered,
        isReviewed,
        timeSpent,
        retakes,
        language,
      } = action.payload;

      const existingAnswer = state.selectedAnswers[questionId] || {};

      return {
        ...state,
        selectedAnswers: {
          ...state.selectedAnswers,
          [questionId]: {
            ...existingAnswer,
            selectedAnswer,
            // Allow updating isAnswered to false (for reset), but preserve existing if undefined
            isAnswered:
              isAnswered !== undefined
                ? isAnswered
                : existingAnswer.isAnswered || false,
            isReviewed,
            timeSpent,
            retakes: retakes || 0,
            language: language || existingAnswer.language || null,
          },
        },
      };

    case RECORD_QUESTION_CHEATING:
      const {
        questionId: qId,
        detectedCheatings: newCheatings,
        snapshots,
      } = action.payload;
      const currentAnswer = state.selectedAnswers[qId] || {};

      const newWebcam = [
        ...(currentAnswer.webCamSnapShots || []),
        ...(snapshots?.webCamSnapShots || []),
      ];
      const newScreen = [
        ...(currentAnswer.screenSnapShots || []),
        ...(snapshots?.screenSnapShots || []),
      ];

      // Track per-question counts for Tab Switches and Fullscreen Exits
      let additionalTabSwitches = 0;
      let additionalFullScreenExits = 0;

      const cheatArray = Array.isArray(newCheatings)
        ? newCheatings
        : [newCheatings];

      cheatArray.forEach((c) => {
        if (typeof c === "string") {
          if (c.toLowerCase().includes("tab switched")) {
            additionalTabSwitches++;
          }
          if (c.toLowerCase().includes("fullscreen exit")) {
            additionalFullScreenExits++;
          }
        }
      });

      return {
        ...state,
        selectedAnswers: {
          ...state.selectedAnswers,
          [qId]: {
            ...currentAnswer,
            isCheatingDetected: true,
            detectedCheatings: [
              ...(currentAnswer.detectedCheatings || []),
              ...cheatArray,
            ],
            webCamSnapShots: newWebcam,
            screenSnapShots: newScreen,
            tabSwitchCount:
              (currentAnswer.tabSwitchCount || 0) + additionalTabSwitches,
            fullScreenExitCount:
              (currentAnswer.fullScreenExitCount || 0) +
              additionalFullScreenExits,
          },
        },
      };

    case RESET_ANSWER:
      const { questionId: selectedQuestionId } = action.payload;
      const resetSelectedAnswers = state.selectedAnswers;

      resetSelectedAnswers[selectedQuestionId].selectedAnswer = null;
      return { ...state, selectedAnswers: resetSelectedAnswers };

    case LOGOUT:
      return {
        ...initialState,
        logout: null,
      };

    case SET_IS_SUBMITTED:
      return {
        ...state,
        isSubmitted: action.payload,
      };

    case SET_ALL_SELECTED_ANSWERS:
      return {
        ...state,
        selectedAnswers: action.payload,
      };

    case SET_PREVIOUS_SPENT_TIME:
      return {
        ...state,
        previousSpentTime: action.payload,
      };

    case SET_CLIENT_ID:
      return {
        ...state,
        clientId: action.payload,
      };

    case SET_JOB_ID:
      return {
        ...state,
        jobId: action.payload,
      };

    case RESET_ALL_ANSWERS:
      return {
        ...state,
        selectedAnswers: {},
        index: 0,
        value: "2", // Reset to first skill tab
        isSubmitted: false,
      };

    case SET_HAS_PROMO_VIDEO:
      return {
        ...state,
        hasPromoVideo: action.payload,
      };

    default:
      return state;
  }
};

export default testReducer;
